<div class='outer'>
  <div class='inner'>
    <h1>{{title}}</h1>
    <div class='sort-search'>
      <div class='sort' [hidden]='sortItems.length === 0' *ngIf='showSort'>
        <label>Sort By</label>
        <button (click)='chooseSortItem($event)'>{{selectedSortName}}</button>
      </div>
      <div class='search' [hidden]='searchPlaceholder.length === 0' *ngIf='showSearch'>
        <label>Search</label>
        <input placeholder='{{searchPlaceholder}}' [(ngModel)]='searchText'>
      </div>
    </div>
  </div>
</div>
